import { render, staticRenderFns } from "./sumarry-table.vue?vue&type=template&id=32977ac5&"
import script from "./sumarry-table.vue?vue&type=script&lang=js&"
export * from "./sumarry-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports